/* eslint-disable import/prefer-default-export */
export enum PhoneType {
    Home = 'home',
    Mobile = 'mobile',
    Office = 'office',
}
